<template>
  <avue-crud
    ref="crud"
    :data="tableData"
    :option="option"
    :table-loading="showLoading"
    :page.sync="page"
    @on-load="onLoad"
    @selection-change="selectionChange"
  >
    <template #header>
      <div>
        <div class="flex align-items marginBottom20">
          <el-button
            size="medium"
            type="primary"
            @click="handleModify(1)"
            class="marginLeft10"
            >修改权限</el-button
          >
          <el-button
            size="medium"
            type="primary"
            @click="handleKickOut(2)"
            class="marginLeft10"
            >踢出分组</el-button
          >
          <el-button
            size="medium"
            type="primary"
            @click="handleAddUser()"
            class="marginLeft10"
            >添加成员</el-button
          >
        </div>
      </div>
    </template>
    <template slot="avatarUrl" slot-scope="{ row }">
      <el-image
        style="width: 80px; height: 80px"
        :src="row.avatarUrl"
        :preview-src-list="[row.avatarUrl]"
      >
      </el-image>
    </template>

    <template slot="gatewayNames" slot-scope="{ row }">
      <div>
        {{
          row.identityType == 1 || row.identityType == 2
            ? "全部网关"
            : row.identityType == 3
            ? row.gatewayNames
            : ""
        }}
      </div>
    </template>
    <template slot="identityType" slot-scope="{ row }">
      <div>
        {{
          row.identityType == 1
            ? "创建者"
            : row.identityType == 2
            ? "管理员"
            : row.identityType == 3
            ? "成员"
            : ""
        }}
      </div>
    </template>
  </avue-crud>
</template>

<script>
import { userList } from "@/api/user/group";

export default {
  name: "index",

  data() {
    return {
      searchData: {
        nickname: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        menu: false,
        selection: true,
        reserveSelection: true,
        selectionFixed: true,
        tip: false,
        selectable: (row, index) => {
          return row.identityType != 1;
        },
        column: [
          {
            label: "用户ID",
            prop: "userId",
          },
          {
            label: "昵称",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "用户头像",
            prop: "avatarUrl",
            width: 150,
          },
          {
            label: "加入时间",
            prop: "createTime",
            width: 150,
          },
          {
            label: "网关",
            prop: "gatewayNames",
            width: 150,
          },
          {
            label: "权限",
            prop: "identityType",
            width: 150,
          },
        ],
      },
    };
  },
  props: {
    id: {
      type: [Number, String],
      default: "",
    },
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        nickname: this.searchData.nickname,
      };

      userList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        id: this.id,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    //编辑
    async handleModify(type) {
      this.$emit("memberId", this.selectedRowKeys, type);
    },
    async handleKickOut(type) {
      this.$emit("memberId", this.selectedRowKeys, type);
    },
    async handleAddUser() {
      this.$emit("groupId", this.tableData);
    },

    //表格左侧选择的数据的
    selectionChange(list) {
      this.selectedRowKeys = list;
      // console.log('选中的数据',list);
      // this.$message.success('选中的数据'+ JSON.stringify(list));
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
  },
};
</script>

<style scoped></style>
